import React, { useRef, useState, useEffect, useCallback } from 'react';
import * as Yup from 'yup';
import { uuid } from 'uuidv4';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';

import { DataGrid, GridColDef, GridCellParams, GridRowId, ptBR } from '@material-ui/data-grid';
import { createMuiTheme, ThemeProvider, makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import ButtonDialog from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Link from '@material-ui/core/Link';
import Checkbox from '@material-ui/core/Checkbox';
import { FiCopy } from 'react-icons/fi';
import { MdDelete, MdEdit, MdClear, MdSkipNext, MdSkipPrevious, MdContentCopy } from 'react-icons/md';
import {
  AiOutlineSearch,
  AiOutlinePlus,
  AiOutlineSave,
  AiFillFastBackward,
  AiFillFastForward,
  AiOutlineCaretDown,
  AiOutlineCaretUp,
} from 'react-icons/ai';
import { RiDeleteBinLine } from 'react-icons/ri';
import { GoPlus } from 'react-icons/go';
import InputComum from '../../components/InputComum';
import InputID from '../../components/InputID';
import Select from '../../components/Select';
import Header from '../../components/Header';
import FormModalDialogConfirm from '../../components/FormModalDialogConfirm';

import api from '../../services/api';
import { useAuth } from '../../hooks/Auth';
import { useToast } from '../../hooks/Toast';

import getListUpdateV2 from '../../utils/getListUpdateV2';
import { getPathGrid } from '../../utils/storagePath';
import getValidationErrors from '../../utils/getValidationErrors';

import {
  ColumnObservacao,
  ColumnInformacao1,
  ColumnInformacao2,
  ColumnInformacao3,
  ColumnInformacao4,
  ColumnInformacao5,
  ColumnID,
  ColumnCompany,
  ColumnDescricaoMenu,
  ColumnDescricaoModulo,
  ColumnDescricaoRelatorio,
  ColumnIdUsuario,
  ColumnUsuario,
} from './GridColumns';

import ICadReportsBi, { emptyCadReportsBi } from './ICadReportsBi';
import IAPICadReportsBi from './IAPICadReportsBi';
import IUsers from './IUsers';
import ICompany from './ICompany';
import {
  Container,
  ContainerFields,
  Tab,
  TabButton,
  TabContent,
  FormFields,
  FormContainer,
  FormNavigate,
  TabTitulo,
  TabButtonArea,
  TabButtonNovo,
  TabButtonDelete,
  TabButtonGridRowHeight,
  SpanFiltro,
  ContainerFilterSelect,
} from './styles';

const useStylesLoading = makeStyles((theme: Theme) =>
  createStyles({
    backdrop: {
      zIndex: theme.zIndex.drawer + 2000,
      color: '#fff',
    },
  }),
);

const theme = createMuiTheme(
  {
    palette: {
      primary: { main: '#006699' },
    },
  },
  ptBR,
);

const titulo = 'R E P O R T S     B I';
const idfieldSelectUser = '22swdf515533rasd12W';
const idfieldSelectUserFilter = '4s54s12W';
// const idfieldSelectCompany = 'uSDiasdy7-92';
const idfieldSelectUsuarioOrigem = 'dc2e95916d118fb29519e84d4f02e0d8';
const idfieldSelectUsuarioDestino = '88cf759ff4b3c15e5e557e21acd6c37a';
const idfieldSelectEmpresaDestino = '3ea6c76347dd4c7167b9c1c83f069003';
const idfieldSelectSubstituirDestino = '3ea6c76347dd4c7167b9c1c83f069077';

const CadReportsBi: React.FC = () => {
  const { user } = useAuth();
  const { addToast } = useToast();
  const formRef = useRef<FormHandles>(null);
  const [cadReportsBi, setCadReportsBi] = useState<ICadReportsBi>();
  const [listCadReportsBi, setListCadReportsBi] = useState<ICadReportsBi[]>([]);
  const [hiddenPesquisar, setHiddenPesquisar] = useState<boolean>(false);
  const [hiddenCadastrar, setHiddenCadastrar] = useState<boolean>(true);
  const [rowIndex, setRowIndex] = useState<number>(0);
  const [rowToEdit, setRowToEdit] = useState(null);
  const [accessKeyDeleteCadReportsBi, setAccessKeyDeleteCadReportsBi] = useState<string>('');
  const [selectedIds, setSelectedIds] = useState<GridRowId[]>([]);
  const [openDeleteSingle, setOpenDeleteSingle] = useState(false);
  const [openDeleteMultiple, setOpenDeleteMultiple] = useState(false);
  const [openLoading, setOpenLoading] = useState(false);
  const cssLoading = useStylesLoading();
  const [gridRowHeight, setGridRowHeight] = useState<number>(46);
  const [listUsers, setListUsers] = useState<IUsers[]>([]);
  const [listUsersDestino, setListUsersDestino] = useState<IUsers[]>([]);
  const [listCompany, setListCompany] = useState<ICompany[]>([]);
  const [openFilter, setOpenFilter] = React.useState(true);
  const [textFiltro, setTextFiltro] = useState<string>('');
  const [openCopy, setOpenCopy] = React.useState(false);
  const [selectedUser, setSelectedUser] = useState<IUsers>();
  const [disableButtomCopy, setDisableButtomCopy] = React.useState(true);

  const handleCloseFilter = useCallback(() => {
    setOpenFilter(false);
  }, []);

  const handleCloseCopy = useCallback(() => {
    setOpenCopy(false);
  }, []);

  const handleGridRowHeightUp = useCallback(async () => {
    const heightValue: number = gridRowHeight + 1;
    setGridRowHeight(heightValue);
    localStorage.setItem(getPathGrid(), heightValue.toString());
  }, [gridRowHeight]);

  const handleGridRowHeightDown = useCallback(async () => {
    const heightValue: number = gridRowHeight - 1;
    setGridRowHeight(heightValue);
    localStorage.setItem(getPathGrid(), heightValue.toString());
  }, [gridRowHeight]);

  const licencaInvalida = useCallback((): boolean => {
    if (!user.license || user.license.id === '') {
      addToast({
        type: 'error',
        title: 'Licença inválida',
        description: 'Usuário não está vinculado a nenhuma licença',
      });

      return true;
    }

    return false;
  }, [addToast, user]);

  const defineCadReportsBi = useCallback(async (inValue: ICadReportsBi) => {
    const temp = { ...inValue };
    setCadReportsBi(temp);
    formRef.current?.setData(temp);
  }, []);

  const OnGridSetRegisterToEdit = useCallback(
    async (params: GridCellParams) => {
      const localRow = params.row as ICadReportsBi;

      setRowIndex(listCadReportsBi.indexOf(localRow));
      setHiddenCadastrar(false);
      setHiddenPesquisar(true);
      setRowToEdit(null);
      defineCadReportsBi(localRow);
    },
    [listCadReportsBi, defineCadReportsBi],
  );

  const onNewRegister = useCallback(async () => {
    defineCadReportsBi(emptyCadReportsBi);
  }, [defineCadReportsBi]);

  const OnSetRegisterToAdd = useCallback(async () => {
    onNewRegister();
    setHiddenCadastrar(false);
    setHiddenPesquisar(true);
  }, [onNewRegister]);

  const OnGridRowDuplicate = useCallback(
    async (inValue: ICadReportsBi | undefined) => {
      if (inValue !== undefined) {
        const newRow: ICadReportsBi = {
          ...inValue,
          access_key: '',
          id: 0,
        };

        defineCadReportsBi(newRow);
        setHiddenCadastrar(false);
        setHiddenPesquisar(true);
      }
    },
    [defineCadReportsBi],
  );

  const OnConfirmationDeleteSingle = useCallback(
    async (inAccessKey: string) => {
      if (licencaInvalida()) return;

      if (inAccessKey === '') return;

      setAccessKeyDeleteCadReportsBi(inAccessKey);
      setOpenDeleteSingle(true);
    },
    [licencaInvalida],
  );

  const colunaAcao: GridColDef = {
    field: 'acao',
    headerName: 'Ação',
    editable: false,
    filterable: false,
    hideSortIcons: true,
    sortable: false,
    disableColumnMenu: true,
    width: 160,
    renderCell: (params: GridCellParams) => (
      <strong>
        <Tooltip title="Editar Registro" placement="top">
          <IconButton color="primary" aria-label="Editar" onClick={() => OnGridSetRegisterToEdit(params)}>
            <MdEdit />
          </IconButton>
        </Tooltip>

        <Tooltip title="Duplicar Registro" placement="top">
          <IconButton
            color="primary"
            aria-label="Duplicar"
            onClick={() => OnGridRowDuplicate(params.row as ICadReportsBi)}
          >
            <FiCopy />
          </IconButton>
        </Tooltip>

        <Tooltip title="Excluir Registro" placement="top">
          <IconButton
            color="primary"
            aria-label="Excluir"
            onClick={() => OnConfirmationDeleteSingle((params.row as ICadReportsBi).access_key)}
          >
            <MdDelete />
          </IconButton>
        </Tooltip>
      </strong>
    ),
  };

  const onClickLink = (inValue: string | undefined | null) => {
    if (!inValue) return;

    window.open(inValue, '_blank', 'noopener,noreferrer');
  };

  const ColumnUrlPowerBi: GridColDef = {
    field: 'url_power_bi',
    headerName: 'Url Power BI',
    width: 500,
    renderCell: (params: GridCellParams) => {
      const urlExtra = '&navContentPaneEnabled=false&filterPaneEnabled=true'
      const localReportSectionPowerBi = (params.row as IAPICadReportsBi).report_section_power_bi
        ?  `&pageName=ReportSection${(params.row as IAPICadReportsBi).report_section_power_bi.replace('ReportSection','')}${urlExtra}`
        : '';
      const localLink = `${params.value?.toString()}${localReportSectionPowerBi}`;
      return (
        <Tooltip title={localLink} placement="top">
          <Link href="#" onClick={() => onClickLink(localLink)}>
            {localLink}
          </Link>
        </Tooltip>
      );
    },
  };

  const columns: GridColDef[] = [
    colunaAcao,
    ColumnCompany,
    ColumnIdUsuario,
    ColumnUsuario,
    ColumnDescricaoModulo,
    ColumnDescricaoMenu,
    ColumnDescricaoRelatorio,
    ColumnUrlPowerBi,
    ColumnObservacao,
    ColumnInformacao1,
    ColumnInformacao2,
    ColumnInformacao3,
    ColumnInformacao4,
    ColumnInformacao5,
    ColumnID,
  ];

  const getCadReportsBi = useCallback(
    async (inValue: string) => {
      const response = await api.post<IAPICadReportsBi[]>(`/cadreportsbi/filter`, {
        license: user.license.id,
        id_usuario: inValue,
        id_company: user.empresa.id,
      });

      const tempList: ICadReportsBi[] = response.data.map(iemList => {
        return {
          ...iemList,
          access_key: iemList.access_key || uuid(),
          company: `${iemList.code}-${iemList.name}[${iemList.cnpj}]`,
        };
      });

      setListCadReportsBi(tempList);

      if (rowToEdit !== null) {
        const findItem = tempList.find(item => item.access_key === rowToEdit);

        if (findItem) {
          defineCadReportsBi(findItem);
          setRowIndex(tempList.indexOf(findItem));
          setHiddenCadastrar(false);
          setHiddenPesquisar(true);
          setRowToEdit(null);
        }
      }
    },
    [user, rowToEdit, defineCadReportsBi],
  );

  const getUsers = useCallback(async () => {
    const response = await api.get<IUsers[]>(`/userlicense/all/${user.license.id}`);
    const list = response.data
      .filter(item => !['suporte@assessortech.com.br'].includes(item.email))
      .sort((a, b) => {
        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
        return 0;
      });
    setListUsers(list);
    if (list.length) {
      setListUsersDestino(list.filter(itemList => itemList.id !== list[0].id));
    }
  }, [user]);

  const getCompany = useCallback(async () => {
    const response = await api.get<ICompany[]>(`/company/${user.license.id}`);
    setListCompany(
      response.data.sort((a, b) => {
        if (a.code.toLowerCase() < b.code.toLowerCase()) return -1;
        if (a.code.toLowerCase() > b.code.toLowerCase()) return 1;
        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
        return 0;
      }),
    );
  }, [user]);

  const getValues = useCallback(async () => {
    if (licencaInvalida()) return;

    setOpenLoading(true);
    await getUsers();
    await getCompany();
    setOpenLoading(false);
    setHiddenPesquisar(false);
  }, [licencaInvalida, getUsers, getCompany]);

  useEffect(() => {
    getValues();

    const rowHeight = localStorage.getItem(getPathGrid());
    if (rowHeight) {
      setGridRowHeight(parseInt(rowHeight, 10));
    }
  }, [getValues]);

  const handleOnRowDeleteSingle = useCallback(async () => {
    setOpenLoading(true);
    await api.delete(`/cadreportsbi/${accessKeyDeleteCadReportsBi}`);
    setListCadReportsBi(OldValue => OldValue.filter(item => item.access_key !== accessKeyDeleteCadReportsBi));
    addToast({
      type: 'success',
      title: 'Removido',
      description: 'Registro excluído com sucesso!',
    });
    setOpenDeleteSingle(false);
    setOpenLoading(false);
  }, [accessKeyDeleteCadReportsBi, addToast]);

  const handleOnRowDeleteMultiple = useCallback(async () => {
    setOpenLoading(true);

    if (selectedIds.length > 0) {
      await Promise.all(
        selectedIds.map(accessKey => {
          setListCadReportsBi(itemList => itemList.filter(item => item.access_key !== accessKey));
          return api.delete(`/cadreportsbi/${accessKey}`);
        }),
      );
      addToast({
        type: 'success',
        title: 'Removido',
        description: 'Registro excluído com sucesso!',
      });
    }
    setSelectedIds([]);
    setOpenDeleteMultiple(false);
    setOpenLoading(false);
  }, [addToast, selectedIds]);

  const handleClick = useCallback((id: string): void => {
    if (id === 'filtro') {
      setOpenFilter(id === 'filtro');
      return;
    }
    if (id === 'copiar') {
      setOpenCopy(id === 'copiar');
      return;
    }
    setHiddenCadastrar(id === 'pesquisar');
    setHiddenPesquisar(id === 'cadastrar');
  }, []);

  const onNextRegister = useCallback(async () => {
    if (rowIndex !== undefined) {
      if (rowIndex < listCadReportsBi.length - 1) {
        const localIndex = rowIndex + 1;
        setRowIndex(localIndex);
        const findItem = listCadReportsBi[localIndex];
        if (findItem) {
          defineCadReportsBi(findItem);
        }
      }
    }
  }, [rowIndex, listCadReportsBi, defineCadReportsBi]);

  const onFirstRegister = useCallback(async () => {
    if (listCadReportsBi.length > 0) {
      setRowIndex(0);
      const findItem = listCadReportsBi[0];
      if (findItem) {
        defineCadReportsBi(findItem);
      }
    }
  }, [listCadReportsBi, defineCadReportsBi]);

  const onLastRegister = useCallback(async () => {
    if (listCadReportsBi.length > 0) {
      setRowIndex(listCadReportsBi.length - 1);
      const findItem = listCadReportsBi[listCadReportsBi.length - 1];
      if (findItem) {
        defineCadReportsBi(findItem);
      }
    }
  }, [listCadReportsBi, defineCadReportsBi]);

  const onPriorRegister = useCallback(async () => {
    if (rowIndex !== undefined) {
      if (rowIndex > 0) {
        const localIndex = rowIndex - 1;
        setRowIndex(localIndex);
        const findItem = listCadReportsBi[localIndex];
        if (findItem) {
          defineCadReportsBi(findItem);
        }
      }
    }
  }, [rowIndex, listCadReportsBi, defineCadReportsBi]);

  const onCancelRegister = useCallback(async () => {
    formRef.current?.setErrors({});

    if (rowIndex !== undefined) {
      const findItem = listCadReportsBi[rowIndex];
      if (findItem) {
        defineCadReportsBi(findItem);
      }
    }
  }, [rowIndex, listCadReportsBi, defineCadReportsBi]);

  const getDescricaoCompanySelectOption = useCallback((value: ICompany): string => {
    if (!value) return '';

    if (value.code) {
      return `${value.code.trim()}-${value.name.trim()}[${value.cnpj.trim()}]`;
    }
    return `${value.name.trim()}[${value.cnpj.trim()}]`;
  }, []);

  const getCompanySelectOption = useCallback(
    (inId: string): ICompany => {
      return listCompany.filter(item => item.id === inId)[0];
    },
    [listCompany],
  );

  const handleSubmit = useCallback(
    async (data: ICadReportsBi, { reset }) => {
      if (licencaInvalida()) return;
      data.id_license = user.license.id;
      data.id_company = user.empresa.id;
      data.company = getDescricaoCompanySelectOption(getCompanySelectOption(user.empresa.id));

      formRef.current?.setErrors({});
      try {
        const schema = Yup.object().shape({
          id_company: Yup.string().required('Empresa é obrigatória'),
          id_usuario: Yup.string().required('Usuário é obrigatório'),
          desc_modulo: Yup.string().required('Módulo é obrigatório'),
          desc_menu: Yup.string().required('Menu é obrigatório'),
          desc_relatorio: Yup.string().required('Relatório é obrigatório'),
          url_power_bi: Yup.string().required('URL Power BI é obrigatório'),
          obs: Yup.string(),
          inf1: Yup.string(),
          inf2: Yup.string(),
          inf3: Yup.string(),
          inf4: Yup.string(),
          inf5: Yup.string(),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        if ([0, '0', null, undefined].includes(data.id)) {
          const findItem = listCadReportsBi.find(
            itemList =>
              itemList.id_company === data.id_company &&
              itemList.id_usuario === data.id_usuario &&
              itemList.desc_modulo === data.desc_modulo &&
              itemList.desc_menu === data.desc_menu &&
              itemList.desc_relatorio === data.desc_relatorio,
          );

          if (findItem) {
            addToast({
              type: 'error',
              title: 'Configuração já existe',
              description: `Já existe uma configuração para ${data.usuario}, com o módulo ${data.desc_modulo}, menu ${data.desc_menu}, relatório ${data.desc_relatorio}, para a empresa ${data.company}!`,
            });
            return;
          }
        }

        setOpenLoading(true);

        const formData: ICadReportsBi = {
          acao: data.acao,
          id: data.id,
          access_key: data.access_key,
          id_license: data.id_license,
          id_company: data.id_company,
          company: data.company,
          id_usuario: data.id_usuario,
          usuario: data.usuario,
          desc_modulo: data.desc_modulo,
          desc_menu: data.desc_menu,
          desc_relatorio: data.desc_relatorio,
          url_power_bi: data.url_power_bi,
          report_section_power_bi: data.report_section_power_bi?.trim(),
          inf1: data.inf1,
          inf2: data.inf2,
          inf3: data.inf3,
          inf4: data.inf4,
          inf5: data.inf5,
          obs: data.obs,
          updated_at: data.updated_at,
          created_at: data.created_at,
        };

        if ([0, '0', null, undefined].includes(data.id)) {
          const response = await api.post(`/cadreportsbi`, {
            ...formData,
            id_license: user.license.id,
            id: 0,
            access_key: '',
          });
          formData.id = response.data.id;
          setListCadReportsBi(oldValues => [...oldValues, formData]);

          addToast({
            type: 'success',
            title: 'Adicionado',
            description: 'Registro adicionado com sucesso!',
          });
        } else {
          await api.put(`/cadreportsbi/${formData.access_key}`, formData);

          setListCadReportsBi(getListUpdateV2(listCadReportsBi, formData));

          addToast({
            type: 'success',
            title: 'Alterado',
            description: 'Registro alterado com sucesso!',
          });
        }
        setHiddenPesquisar(true);
        reset();
        setOpenLoading(false);
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
        }
        setOpenLoading(false);
      }
    },
    [licencaInvalida, listCadReportsBi, addToast, getCompanySelectOption, getDescricaoCompanySelectOption, user],
  );

  const handleOnFilter = useCallback(async () => {
    const fieldSelect = document.getElementById(idfieldSelectUserFilter);
    if (fieldSelect) {
      const id = (fieldSelect as HTMLSelectElement).value;
      const findUser = listUsers.find(item => id === item.id);
      if (findUser) {
        setOpenLoading(true);
        await getCadReportsBi(findUser.id_user);

        setSelectedUser(findUser);
        setTextFiltro(`   Filtrado por: ${findUser.name} [${findUser.email}]`);
        setOpenLoading(false);
      }
    }

    setOpenFilter(false);
    handleClick('pesquisar');
  }, [listUsers, getCadReportsBi, handleClick]);

  const handleOnCopy = useCallback(async () => {
    const [fieldSelectFieldSelectUsuarioDestino, fieldSelectFieldSelectEmpresaDestino, fieldSelectSubstituirDestino] = [
      document.getElementById(idfieldSelectUsuarioDestino),
      document.getElementById(idfieldSelectEmpresaDestino),
      document.getElementById(idfieldSelectSubstituirDestino),
    ];

    if (fieldSelectFieldSelectUsuarioDestino && fieldSelectFieldSelectEmpresaDestino) {
      const idUsuarioDestino = (fieldSelectFieldSelectUsuarioDestino as HTMLSelectElement).value;
      const idEmpresaDestino = (fieldSelectFieldSelectEmpresaDestino as HTMLSelectElement).value;
      let substituirDestino = false;
      if (fieldSelectSubstituirDestino) {
        substituirDestino = (fieldSelectSubstituirDestino as HTMLInputElement).checked ? true : false;
      }

      const localIds = listCadReportsBi
        .filter(itemList => selectedIds.includes(itemList.access_key))
        .map(itemList => itemList.id);

      let idUsuarioOrigem: string = '';
      if (localIds.length && selectedUser) {
        idUsuarioOrigem = selectedUser.id_user;
      } else {
        const fieldSelectFieldSelectUsuarioOrigem = document.getElementById(idfieldSelectUsuarioOrigem);
        if (fieldSelectFieldSelectUsuarioOrigem) {
          idUsuarioOrigem = (fieldSelectFieldSelectUsuarioOrigem as HTMLSelectElement).value;
        }
      }
      setOpenLoading(true);
      try {
        await api.post<IAPICadReportsBi[]>(`/cadreportsbi/copy`, {
          license: user.license.id,
          id_company_origem: user.empresa.id,
          id_usuario_origem: idUsuarioOrigem,
          id_company_destino: idEmpresaDestino,
          id_usuario_destino: idUsuarioDestino,
          reports: localIds,
          substituir: substituirDestino,
        });
        setOpenLoading(false);
        addToast({
          type: 'success',
          title: 'Copiado',
          description: 'Informações copiadas com sucesso!',
        });
        setSelectedIds([]);
      } catch (err) {
        addToast({
          type: 'error',
          title: 'Não foi possível realizar a cópia',
          description: '',
        });
        setOpenLoading(false);
      }
    }
    setOpenCopy(false);
  }, [user, addToast, selectedIds, listCadReportsBi, selectedUser]);

  const onChangeUsuarioOrigem = useCallback(
    async (event: React.ChangeEvent<{ value: unknown }>) => {
      const localValue = event.target.value as string;
      setListUsersDestino(listUsers.filter(itemList => itemList.id !== localValue));
    },
    [listUsers],
  );

  const onChangeCheckbox = (event: React.ChangeEvent<{ checked: unknown }>) => {
    const localValue = event.target.checked as boolean;
    setDisableButtomCopy(!localValue);
  };

  return (
    <Container>
      <Header />

      <Tab>
        <TabButtonArea>
          <TabButton id="pesquisar" isActive={!hiddenPesquisar} onClick={() => handleClick('pesquisar')}>
            Listagem
          </TabButton>
          {selectedUser && selectedUser.admin && (
            <TabButton id="cadastrar" isActive={!hiddenCadastrar} onClick={() => handleClick('cadastrar')}>
              Cadastro
            </TabButton>
          )}

          <Tooltip title="Reduzir o tamanho da linha" placement="top">
            <TabButtonGridRowHeight id="gridrowheightdown" onClick={() => handleGridRowHeightDown()}>
              <AiOutlineCaretDown />
            </TabButtonGridRowHeight>
          </Tooltip>

          <Tooltip title="Aumentar o tamanho da linha" placement="top">
            <TabButtonGridRowHeight id="gridrowheightup" onClick={() => handleGridRowHeightUp()}>
              <AiOutlineCaretUp />
            </TabButtonGridRowHeight>
          </Tooltip>

          <Tooltip title="Pesquisar" placement="top">
            <TabButton id="filtro" isActive={false} onClick={() => handleClick('filtro')}>
              <AiOutlineSearch />
            </TabButton>
          </Tooltip>

          <Tooltip title="Copiar Registro" placement="top">
            <TabButton id="Copiar" isActive={false} onClick={() => handleClick('copiar')}>
              <FiCopy />
            </TabButton>
          </Tooltip>

          {selectedUser && selectedUser.admin && (
            <Tooltip title="Novo Registro" placement="top">
              <TabButtonNovo id="new_register" onClick={() => OnSetRegisterToAdd()}>
                <GoPlus />
                Novo
              </TabButtonNovo>
            </Tooltip>
          )}

          <Tooltip title="Remover Registros Selecionados" placement="top">
            <span>
              <span hidden={selectedIds.length <= 0}>
                <TabButtonDelete
                  id="remove_all"
                  onClick={() => {
                    setAccessKeyDeleteCadReportsBi('');
                    setOpenDeleteMultiple(true);
                  }}
                >
                  <RiDeleteBinLine />
                  Remover
                </TabButtonDelete>
              </span>
            </span>
          </Tooltip>
        </TabButtonArea>

        <TabTitulo>
          <span>{titulo}</span>
        </TabTitulo>
      </Tab>
      <SpanFiltro>{textFiltro}</SpanFiltro>

      <TabContent id="pesquisar" isActive={!hiddenPesquisar}>
        <div style={{ height: '85vh', width: '100%' }}>
          <ThemeProvider theme={theme}>
            <DataGrid
              rows={listCadReportsBi}
              columns={columns}
              rowHeight={gridRowHeight}
              checkboxSelection
              selectionModel={selectedIds}
              disableSelectionOnClick
              getRowId={r => r.access_key}
              onSelectionModelChange={e => setSelectedIds(e.selectionModel)}
            />
          </ThemeProvider>
        </div>
      </TabContent>

      {selectedUser && selectedUser.admin && (
        <TabContent id="cadasto" isActive={!hiddenCadastrar}>
          <Form ref={formRef} onSubmit={handleSubmit} initialData={cadReportsBi}>
            <FormContainer>
              <FormNavigate>
                <Tooltip title="Novo Registro" placement="top">
                  <IconButton color="primary" aria-label="adicionar" onClick={() => onNewRegister()}>
                    <AiOutlinePlus />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Duplicar Registro" placement="top">
                  <IconButton color="primary" aria-label="Duplicar" onClick={() => OnGridRowDuplicate(cadReportsBi)}>
                    <MdContentCopy />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Excluir Registro" placement="top">
                  <IconButton
                    color="primary"
                    aria-label="Excluir"
                    disabled={!cadReportsBi?.id}
                    onClick={() => OnConfirmationDeleteSingle(cadReportsBi ? cadReportsBi.access_key : '')}
                  >
                    <RiDeleteBinLine />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Cancelar" placement="top">
                  <IconButton type="reset" color="primary" aria-label="Cancelar" onClick={() => onCancelRegister()}>
                    <MdClear />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Salvar" placement="top">
                  <IconButton type="submit" color="primary" aria-label="Confirmar">
                    <AiOutlineSave />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Primeiro Registro" placement="top">
                  <IconButton color="primary" aria-label="Primeiro" onClick={() => onFirstRegister()}>
                    <AiFillFastBackward />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Registro Anterior" placement="top">
                  <IconButton color="primary" aria-label="Anterior" onClick={() => onPriorRegister()}>
                    <MdSkipPrevious />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Próximo Registro" placement="top">
                  <IconButton color="primary" aria-label="Próximo" onClick={() => onNextRegister()}>
                    <MdSkipNext />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Último Registro" placement="top">
                  <IconButton color="primary" aria-label="Último registro" onClick={() => onLastRegister()}>
                    <AiFillFastForward />
                  </IconButton>
                </Tooltip>
              </FormNavigate>

              <FormFields>
                <ContainerFields field="T100">
                  <span>Empresa:</span>
                  <div>
                    <span>
                      {user.empresa.name.trim()}[{user.empresa.cnpj.trim()}]
                    </span>
                  </div>
                  {/* <Select id={idfieldSelectCompany} name="id_company">
                  {listCompany.map(item => (
                    <option key={item.id} value={item.id}>
                      {getDescricaoCompanySelectOption(item)}
                    </option>
                  ))}
                </Select> */}
                </ContainerFields>

                <ContainerFields field="T100">
                  <span>Usuário:</span>
                  <Select id={idfieldSelectUser} name="id_usuario">
                    {listUsers
                      .filter(itemUser => itemUser.admin)
                      .map(itemUser => (
                        <option key={itemUser.id_user} value={itemUser.id_user}>
                          {itemUser.name} [{itemUser.email}]
                        </option>
                      ))}
                  </Select>
                </ContainerFields>

                <ContainerFields field="T100">
                  <span>Módulo:</span>
                  <InputComum name="desc_modulo" />
                </ContainerFields>

                <ContainerFields field="T100">
                  <span>Menu:</span>
                  <InputComum name="desc_menu" />
                </ContainerFields>

                <ContainerFields field="T100">
                  <span>Relatório:</span>
                  <InputComum name="desc_relatorio" />
                </ContainerFields>

                <ContainerFields field="T100">
                  <span>URL Power BI:</span>
                  <InputComum name="url_power_bi" />
                </ContainerFields>

                <ContainerFields field="T100">
                  <span>Report section:</span>
                  <InputComum name="report_section_power_bi" />
                </ContainerFields>

                <ContainerFields field="T100">
                  <span>Observação:</span>
                  <InputComum name="obs" />
                </ContainerFields>

                <ContainerFields field="T100">
                  <span>Informação 1:</span>
                  <InputComum name="inf1" />
                </ContainerFields>

                <ContainerFields field="T100">
                  <span>Informação 2:</span>
                  <InputComum name="inf2" />
                </ContainerFields>

                <ContainerFields field="T100">
                  <span>Informação 3:</span>
                  <InputComum name="inf3" />
                </ContainerFields>

                <ContainerFields field="T100">
                  <span>Informação 4:</span>
                  <InputComum name="inf4" />
                </ContainerFields>

                <ContainerFields field="T100">
                  <span>Informação 5:</span>
                  <InputComum name="inf5" />
                </ContainerFields>

                <ContainerFields field="TID">
                  <InputID name="id" hidden />
                  <InputID name="access_key" hidden />
                  <InputID name="id_license" hidden />
                  <InputID name="company" hidden />
                  <InputID name="usuario" hidden />
                  <InputID name="data_ultima_atualizacao" hidden />
                </ContainerFields>
              </FormFields>
            </FormContainer>
          </Form>
        </TabContent>
      )}

      <FormModalDialogConfirm
        open={openDeleteSingle}
        onClose={() => setOpenDeleteSingle(false)}
        onConfirm={() => handleOnRowDeleteSingle()}
        buttonCancelText="Cancelar"
        buttonConfirmText="Sim"
        formTitle="Excluir?"
        messageConfirm="Tem certeza que deseja excluir?"
      />

      <FormModalDialogConfirm
        open={openDeleteMultiple}
        onClose={() => setOpenDeleteMultiple(false)}
        onConfirm={() => handleOnRowDeleteMultiple()}
        buttonCancelText="Cancelar"
        buttonConfirmText="Sim"
        formTitle="Excluir?"
        messageConfirm="Tem certeza que deseja excluir todos os registros selecionados?"
      />

      <Dialog
        open={openFilter}
        onClose={handleCloseFilter}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Filtro</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">Usuário:</DialogContentText>
          <ContainerFields field="T100">
            <ContainerFilterSelect>
              <select id={idfieldSelectUserFilter}>
                {listUsers.map(itemUser => (
                  <option key={itemUser.id} value={itemUser.id}>
                    {itemUser.name} [{itemUser.email}]
                  </option>
                ))}
              </select>
            </ContainerFilterSelect>
          </ContainerFields>
        </DialogContent>
        <DialogActions>
          <ButtonDialog onClick={handleCloseFilter} color="primary" autoFocus>
            Cancelar
          </ButtonDialog>
          <ButtonDialog onClick={handleOnFilter} color="primary">
            Filtrar
          </ButtonDialog>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openCopy}
        onClose={handleCloseCopy}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          style: {
            minWidth: '70vh',
          },
        }}
      >
        <div style={{ minWidth: '70vh' }}>
          <DialogTitle id="alert-dialog-title">Filtro</DialogTitle>
          <DialogContent>
            <ContainerFields field="T100">
              <span>Empresa origem:</span>
              <div>
                <span style={{ fontWeight: 'bold' }}>
                  {user.empresa.name.trim()}[{user.empresa.cnpj.trim()}]
                </span>
              </div>
            </ContainerFields>

            <ContainerFields field="T100">
              <span>Usuário origem:</span>
              {selectedIds.length ? (
                <div>
                  <span style={{ fontWeight: 'bold' }}>
                    {selectedUser?.name}[{selectedUser?.email}]
                  </span>
                </div>
              ) : (
                <ContainerFilterSelect>
                  <select id={idfieldSelectUsuarioOrigem} onChange={onChangeUsuarioOrigem}>
                    {listUsers.map(item => (
                      <option key={item.id_user} value={item.id_user}>
                        {item.name} [{item.email}]
                      </option>
                    ))}
                  </select>
                </ContainerFilterSelect>
              )}
            </ContainerFields>

            <ContainerFields field="T100">
              <span>Empresa destino:</span>
              <ContainerFilterSelect>
                <select id={idfieldSelectEmpresaDestino}>
                  {listCompany.map(item => (
                    <option key={item.id} value={item.id}>
                      {getDescricaoCompanySelectOption(item)}
                    </option>
                  ))}
                </select>
              </ContainerFilterSelect>
            </ContainerFields>

            <ContainerFields field="T100">
              <span>Usuário destino:</span>
              <ContainerFilterSelect>
                <select id={idfieldSelectUsuarioDestino}>
                  {listUsersDestino.map(item => (
                    <option key={item.id_user} value={item.id_user}>
                      {item.name} [{item.email}]
                    </option>
                  ))}
                </select>
              </ContainerFilterSelect>
            </ContainerFields>

            <ContainerFields
              field="T100"
              style={{
                marginLeft: '-10px',
                marginTop: '16px',
                marginBottom: '10px',
              }}
            >
              <Checkbox id={idfieldSelectSubstituirDestino} color="primary" onChange={onChangeCheckbox} />
              <span style={{ fontWeight: 'bold' }}>
                {selectedIds.length
                  ? 'Substituir as informações de destino pelas informações selecionadas'
                  : 'Substituir TODAS as informações de destino'}
              </span>
            </ContainerFields>
          </DialogContent>
          <DialogActions>
            <ButtonDialog onClick={handleCloseCopy} color="primary" autoFocus>
              Cancelar
            </ButtonDialog>
            <ButtonDialog onClick={handleOnCopy} color="primary" disabled={disableButtomCopy}>
              Copiar
            </ButtonDialog>
          </DialogActions>
        </div>
      </Dialog>

      <Backdrop className={cssLoading.backdrop} open={openLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Container>
  );
};

export default CadReportsBi;
